/*
 *  This file global.reducer.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */


import { createReducer, on } from "@ngrx/store"
import { enterpriseEnableDisableSuccess, employeecontestEnableDisableSuccess, loadBadgeFeedSuccess, refreshPageAccessRightSuccess, subscribeModuleSuccess, updateGlboalStateFromStorage, validateFeatureSuccess, workforceSettingSuccess, loadFeedCountSuccess, showRefreshFeed, loadRankDetailSuccess, loadEnterpriseSuccess, loadDepartmentsSuccess, loadSubDepartmentsSuccess, loadBusinessUnitsSuccess, loadLevelsSuccess, loadDesignationsSuccess, loadGradesSuccess, loadSubBranchesSuccess, loadBranchesSuccess, loadRegionsSuccess, loadCompaniesSuccess, loadCountriesSuccess, loadStatesSuccess, loadCitiesSuccess, showRefreshJobOpening, loadJobOpeningSuccess, loadSocialWallWidgetSuccess, loadRecruiterAccessSettingSuccess, loadGeneralSettingsSuccess, loadRecruitmentGeneralSettingSuccess, loadOneAIFeatureSuccess, loadTaxRegimeSuccess, loadTimeOfficeExtensionSuccess, loadMoodbotDetailSuccess, loadMoodbotReasionListSuccess, loadPayrollGeneralSettingSuccess, loadWorkflowInboxSettingSuccess, loadHelpdeskTicketFeedbackSuccess, loadLegoOrgIdSuccess } from "./global.action";
import { EGlobalStateProcessId, EGlobalStateStoreNames, IMoodSettingType, TContestEnableDisableResponse, TCoreFeatureValidate, TFeedData, TPageAccessRightStoreData, TReferralData, TTaxRegimeResponse, TWorkforceSetupSettingResponse, TWorkflowInboxSetting, THelpdeskTicketFeedback } from "./global.constants";
import { TSubscribeModuleResponse } from "src/app/modules/team/team-dashboards/team-dashboards.model";
import { TGeneralEngageSettingResponse, IWidgetSequnceResponse } from "src/app/modules/enterprise-wall/social-enterpise-wall/social-wall.model";
import { TGeneralSettingAPIResponse, TRecruiterAccessSettingAPIResponse } from "src/app/global/models/recruitment-module-independent.model";
import { FeatureModel } from "src/app/modules/core/integaration/one-ai/one-ai.model";
import { TExtensionSetting } from "src/app/modules/core/time-office/time-office-setting/time-office-setting/time-office-setting.model";
import { IMoodReason } from "src/app/modules/core/engage/moodbot-setting/moodbot.service";
import { PayrollGeneralSettingModel } from "src/app/global/models/common.models";



export type TGlobalStateProcessVersion<T> = T & {
  versionId?: string,
  processId: number,
  storename: string,
  employeeId?: number,
  domainCode?: string,
  date?: Date | string
}


export type TGlobalState = {
  aux: {
    refreshFeed: boolean,
    processId: number
  },
  [EGlobalStateStoreNames.Feed]: TGlobalStateProcessVersion<{
    data: TFeedData,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.EnterpriseContest]: TGlobalStateProcessVersion<{
    data: TContestEnableDisableResponse[] | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.EmployeeContest]: TGlobalStateProcessVersion<{
    data: { disabled: boolean } | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.PageAccessRights]: TGlobalStateProcessVersion<{
    data: TPageAccessRightStoreData,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.SubscriberModules]: TGlobalStateProcessVersion<{
    data: TSubscribeModuleResponse | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.WorkforceSetupSetting]: TGlobalStateProcessVersion<{
    data: Map<number, TWorkforceSetupSettingResponse>,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.ValidateFeature]: TGlobalStateProcessVersion<{
    data: Map<number, TCoreFeatureValidate>,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.RankDetail]: TGlobalStateProcessVersion<{
    data: { rankDetails: any[] | null, versionId: string | null },
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.Enterprise]: TGlobalStateProcessVersion<{
    data: any,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.Departments]: TGlobalStateProcessVersion<{
    data: any[],
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.SubDepartment]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.BusinessUnit]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Level]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Designation]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Grade]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.SubBranch]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Branch]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Region]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.Company]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.GeneralSettings]: TGlobalStateProcessVersion<{
    data: TGeneralEngageSettingResponse | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.Country]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
  }>,
  [EGlobalStateStoreNames.State]: TGlobalStateProcessVersion<{
    data: any[];
    loading: boolean;
    processId: number;
    storename: string;
  }>,
  [EGlobalStateStoreNames.City]: {
    data: any[];
    loading: boolean;
    processId: number;
    storename: string;
  },
  [EGlobalStateStoreNames.Referralposting]: TGlobalStateProcessVersion<{
    data: TReferralData,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.SocialWallWidget]: TGlobalStateProcessVersion<{
    data: {
      themeId: string,
      isEmployeeEditable: boolean,
      employeeWidgets: Array<IWidgetSequnceResponse>
    } | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.RecruiterAccessSetting]: TGlobalStateProcessVersion<{
    data: TRecruiterAccessSettingAPIResponse[],
    versionId: string,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.RecruitmentGeneralSetting]: TGlobalStateProcessVersion<{
    data: TGeneralSettingAPIResponse[],
    versionId: string,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.OneAIFeature]: TGlobalStateProcessVersion<{
    data: FeatureModel[],
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.TaxRegime]: TGlobalStateProcessVersion<{
    data: TTaxRegimeResponse | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.TimeOfficeExtension]: TGlobalStateProcessVersion<{
    data: TExtensionSetting[],
    loading:boolean
  }>,
  [EGlobalStateStoreNames.MoodbotDetail]: TGlobalStateProcessVersion<{
    data: IMoodSettingType[],
    loading:boolean
  }>,
  [EGlobalStateStoreNames.MoodbotReasionList]: TGlobalStateProcessVersion<{
    data: IMoodReason[],
    loading:boolean
  }>,
  [EGlobalStateStoreNames.PayrollGeneralSetting]: TGlobalStateProcessVersion<{
    data: PayrollGeneralSettingModel | null,
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.WorkflowInboxSetting]: TGlobalStateProcessVersion<{
    data: TWorkflowInboxSetting[],
    loading: boolean,
  }>,
  [EGlobalStateStoreNames.HelpdeskTicketFeedback]: TGlobalStateProcessVersion<{
    data: THelpdeskTicketFeedback[],
    loading: boolean,
  }>
};


export const IGlobalState: TGlobalState = {
  aux: {
    refreshFeed: false,
    processId: 0
  },
  [EGlobalStateStoreNames.Feed]: {
    data: {
      countData: {
        versionId: "1",
        countInfo: null,
      },
      feedCards: {
        cards: [],
        versionId: "1"
      }
    },
    loading: false,
    processId: EGlobalStateProcessId.Feed,
    storename: EGlobalStateStoreNames.Feed,
  },
  [EGlobalStateStoreNames.EnterpriseContest]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.EnterpriseContest,
    storename: EGlobalStateStoreNames.EnterpriseContest,
  },
  [EGlobalStateStoreNames.EmployeeContest]: {
    data: { disabled: false },
    loading: false,
    processId: EGlobalStateProcessId.EmployeeContest,
    storename: EGlobalStateStoreNames.EmployeeContest,
  },
  [EGlobalStateStoreNames.PageAccessRights]: {
    data: {
      menuAccess: null,
      menuAction: null,
      menuList: null,
      refresh: false
    },
    loading: false,
    processId: EGlobalStateProcessId.PageAccessRights,
    storename: EGlobalStateStoreNames.PageAccessRights,
  },
  [EGlobalStateStoreNames.SubscriberModules]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.SubscriberModules,
    storename: EGlobalStateStoreNames.SubscriberModules,
  },
  [EGlobalStateStoreNames.ValidateFeature]: {
    data: new Map<number, TCoreFeatureValidate>(),
    processId: EGlobalStateProcessId.ValidateFeature,
    loading: false,
    storename: EGlobalStateStoreNames.ValidateFeature,
  },
  [EGlobalStateStoreNames.WorkforceSetupSetting]: {
    data: new Map<number, TWorkforceSetupSettingResponse>(),

    processId: EGlobalStateProcessId.WorkforceSetupSetting,
    loading: false,
    storename: EGlobalStateStoreNames.WorkforceSetupSetting,
  },
  [EGlobalStateStoreNames.RankDetail]: {
    data: {
      rankDetails: null,
      versionId: null,
    },
    loading: false,
    processId: EGlobalStateProcessId.RankDetail,
    storename: EGlobalStateStoreNames.RankDetail,
  },
  [EGlobalStateStoreNames.Enterprise]: {
    data: {
      // null until the Enterprise API actually resolves — processId 10 is shared with
      // the Lego OrgId API, so a cached row can exist before this half has been fetched.
      enterprise: null,
      legoOrgId: "",
      versionId: null
    },
    loading: false,
    processId: EGlobalStateProcessId.Enterprise,
    storename: EGlobalStateStoreNames.Enterprise,
  },
  [EGlobalStateStoreNames.Departments]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Departments,
    storename: EGlobalStateStoreNames.Departments,
  },
  [EGlobalStateStoreNames.SubDepartment]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.SubDepartment,
    storename: EGlobalStateStoreNames.SubDepartment,
  },
  [EGlobalStateStoreNames.BusinessUnit]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.BusinessUnit,
    storename: EGlobalStateStoreNames.BusinessUnit,
  },
  [EGlobalStateStoreNames.Level]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Level,
    storename: EGlobalStateStoreNames.Level,
  },
  [EGlobalStateStoreNames.Designation]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Designation,
    storename: EGlobalStateStoreNames.Designation,
  },
  [EGlobalStateStoreNames.Grade]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Grade,
    storename: EGlobalStateStoreNames.Grade,
  },
  [EGlobalStateStoreNames.SubBranch]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.SubBranch,
    storename: EGlobalStateStoreNames.SubBranch,
  },
  [EGlobalStateStoreNames.Branch]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Branch,
    storename: EGlobalStateStoreNames.Branch,
  },
  [EGlobalStateStoreNames.Region]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Region,
    storename: EGlobalStateStoreNames.Region,
  },
  [EGlobalStateStoreNames.Company]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Company,
    storename: EGlobalStateStoreNames.Company,
  },
  [EGlobalStateStoreNames.GeneralSettings]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.GeneralSettings,
    storename: EGlobalStateStoreNames.GeneralSettings,
  },
  [EGlobalStateStoreNames.Country]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.Country,
    storename: EGlobalStateStoreNames.Country,
  },
  [EGlobalStateStoreNames.State]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.State,
    storename: EGlobalStateStoreNames.State,
  },
  [EGlobalStateStoreNames.City]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.City,
    storename: EGlobalStateStoreNames.City
  },
  [EGlobalStateStoreNames.Referralposting]: {
    data: {
      versionId: "1",
      data: [],
    },
    loading: false,
    processId: EGlobalStateProcessId.Referralposting,
    storename: EGlobalStateStoreNames.Referralposting,
  },
  [EGlobalStateStoreNames.SocialWallWidget]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.SocialWallWidget,
    storename: EGlobalStateStoreNames.SocialWallWidget,
  },
  [EGlobalStateStoreNames.RecruiterAccessSetting]: {
    data: [],
    loading: false,
    versionId: "1",
    processId: EGlobalStateProcessId.RecruiterAccessSetting,
    storename: EGlobalStateStoreNames.RecruiterAccessSetting,
  },
  [EGlobalStateStoreNames.RecruitmentGeneralSetting]: {
    data: [],
    loading: false,
    versionId: "1",
    processId: EGlobalStateProcessId.RecruitmentGeneralSetting,
    storename: EGlobalStateStoreNames.RecruitmentGeneralSetting,
  },
  [EGlobalStateStoreNames.OneAIFeature]: {
    data: [],
    processId: EGlobalStateProcessId.OneAIFeature,
    loading: false,
    storename: EGlobalStateStoreNames.OneAIFeature,
  },
  [EGlobalStateStoreNames.TaxRegime]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.TaxRegime,
    storename: EGlobalStateStoreNames.TaxRegime,
  },
  [EGlobalStateStoreNames.TimeOfficeExtension]:{
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.TimeOfficeExtension,
    storename: EGlobalStateStoreNames.TimeOfficeExtension
  },
  [EGlobalStateStoreNames.MoodbotDetail]:{
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.MoodbotDetail,
    storename: EGlobalStateStoreNames.MoodbotDetail
  },
  [EGlobalStateStoreNames.MoodbotReasionList]:{
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.MoodbotReasionList,
    storename: EGlobalStateStoreNames.MoodbotReasionList
  },
  [EGlobalStateStoreNames.PayrollGeneralSetting]: {
    data: null,
    loading: false,
    processId: EGlobalStateProcessId.PayrollGeneralSetting,
    storename: EGlobalStateStoreNames.PayrollGeneralSetting,
  },
  [EGlobalStateStoreNames.WorkflowInboxSetting]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.WorkflowInboxSetting,
    storename: EGlobalStateStoreNames.WorkflowInboxSetting
  },
  [EGlobalStateStoreNames.HelpdeskTicketFeedback]: {
    data: [],
    loading: false,
    processId: EGlobalStateProcessId.HelpdeskTicketFeedback,
    storename: EGlobalStateStoreNames.HelpdeskTicketFeedback
  }
};

export const hroneGlobalReducer = createReducer(
  IGlobalState,
  on(updateGlboalStateFromStorage, (istate, { state }): TGlobalState => {
    const newState = structuredClone(IGlobalState);
    state.forEach((s: any) => {
      newState[s.storename as keyof TGlobalState] = s;
    })
    return state.length > 0 ? { ...istate, ...newState } : { ...istate }
  }),
  on(loadBadgeFeedSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, feed: { ...state.feed, data: { countData: state.feed.data.countData, feedCards: { cards: data, versionId } }, loading: false, processId: EGlobalStateProcessId.Feed, versionId, employeeId, domainCode }, aux: { ...state.aux, refreshFeed: false } }
  }),
  on(loadFeedCountSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, feed: { ...state.feed, data: { feedCards: state.feed.data.feedCards, countData: { countInfo: data, versionId } }, loading: false, processId: EGlobalStateProcessId.Feed, versionId, employeeId, domainCode } }
  }),
  on(refreshPageAccessRightSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {

    return { ...state, pageaccessrights: { ...state[EGlobalStateStoreNames.PageAccessRights], data, loading: false, processId: EGlobalStateProcessId.PageAccessRights, versionId, employeeId, domainCode } }
  }),
  on(enterpriseEnableDisableSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, enterprisecontest: { ...state[EGlobalStateStoreNames.EnterpriseContest], data, loading: false, processId: EGlobalStateProcessId.EnterpriseContest, versionId, employeeId, domainCode } }
  }),
  on(employeecontestEnableDisableSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, employeecontest: { ...state[EGlobalStateStoreNames.EmployeeContest], data, loading: false, processId: EGlobalStateProcessId.EmployeeContest, versionId, employeeId, domainCode } }
  }),
  on(subscribeModuleSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, subscribermodules: { ...state[EGlobalStateStoreNames.SubscriberModules], data, loading: false, processId: EGlobalStateProcessId.SubscriberModules, versionId, employeeId, domainCode } }
  }),
  on(validateFeatureSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, validatefeature: { ...state[EGlobalStateStoreNames.ValidateFeature], data, loading: false, processId: EGlobalStateProcessId.ValidateFeature, versionId, employeeId, domainCode } }
  }),
  on(workforceSettingSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, workforcesetupsetting: { ...state[EGlobalStateStoreNames.WorkforceSetupSetting], data, loading: false, processId: EGlobalStateProcessId.WorkforceSetupSetting, versionId, employeeId, domainCode } }
  }),
  on(showRefreshFeed, (state, { show }): TGlobalState => {
    return { ...state, aux: { ...state.aux, refreshFeed: show } }
  }),
  on(loadRankDetailSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, rankdetail: { ...state[EGlobalStateStoreNames.RankDetail], data: { rankDetails: data, versionId }, loading: false, processId: EGlobalStateProcessId.RankDetail, versionId, employeeId, domainCode } }
  }),
  on(loadEnterpriseSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return {
      ...state,
      enterprise: {
        ...state[EGlobalStateStoreNames.Enterprise],
        data: {
          ...state[EGlobalStateStoreNames.Enterprise].data,
          enterprise: data,
          versionId
        },
        loading: false,
        processId: EGlobalStateProcessId.Enterprise,
        versionId,
        employeeId,
        domainCode
      }
    }
  }),
  on(loadLegoOrgIdSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return {
      ...state,
      enterprise: {
        ...state[EGlobalStateStoreNames.Enterprise],
        data: {
          ...state[EGlobalStateStoreNames.Enterprise].data,
          legoOrgId: data,
          versionId
        },
        loading: false,
        processId: EGlobalStateProcessId.Enterprise,
        versionId,
        employeeId,
        domainCode
      }
    }
  }),
  on(loadDepartmentsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, departments: { ...state[EGlobalStateStoreNames.Departments], data, loading: false, processId: EGlobalStateProcessId.Departments, versionId, employeeId, domainCode } }
  }),
  on(loadSubDepartmentsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, [EGlobalStateStoreNames.SubDepartment]: { ...state[EGlobalStateStoreNames.SubDepartment], data, loading: false, processId: EGlobalStateProcessId.SubDepartment, versionId, employeeId, domainCode } }
  }),
  on(loadBusinessUnitsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, businessunit: { ...state[EGlobalStateStoreNames.BusinessUnit], data, loading: false, processId: EGlobalStateProcessId.BusinessUnit, versionId, employeeId, domainCode } }
  }),
  on(loadLevelsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, level: { ...state[EGlobalStateStoreNames.Level], data, loading: false, processId: EGlobalStateProcessId.Level, versionId, employeeId, domainCode } }
  }),
  on(loadDesignationsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, designation: { ...state[EGlobalStateStoreNames.Designation], data, loading: false, processId: EGlobalStateProcessId.Designation, versionId, employeeId, domainCode } }
  }),
  on(loadGradesSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, grade: { ...state[EGlobalStateStoreNames.Grade], data, loading: false, processId: EGlobalStateProcessId.Grade, versionId, employeeId, domainCode } }
  }),
  on(loadSubBranchesSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, subbranch: { ...state[EGlobalStateStoreNames.SubBranch], data, loading: false, processId: EGlobalStateProcessId.SubBranch, versionId, employeeId, domainCode } }
  }),
  on(loadBranchesSuccess, (state, { data, storename, versionId, domainCode, employeeId }) => ({
    ...state,
    [storename]: {
      data,
      versionId,
      domainCode,
      employeeId,
      processId: EGlobalStateProcessId.Branch
    }
  })),
  on(loadRegionsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, [EGlobalStateStoreNames.Region]: { ...state[EGlobalStateStoreNames.Region], data, loading: false, processId: EGlobalStateProcessId.Region, versionId, employeeId, domainCode } }
  }),
  on(loadCompaniesSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return {
      ...state,
      company: {
        ...state[EGlobalStateStoreNames.Company],
        data,
        loading: false,
        processId: EGlobalStateProcessId.Company,
        versionId,
        employeeId,
        domainCode
      }
    };
  }),
  on(loadCountriesSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return {
      ...state,
      country: {
        ...state[EGlobalStateStoreNames.Country],
        data,
        loading: false,
        processId: EGlobalStateProcessId.Country,
        versionId,
        employeeId,
        domainCode
      }
    };
  }),
  on(loadStatesSuccess, (state, { data, storename, versionId, domainCode, employeeId }) => ({
    ...state,
    [storename as keyof TGlobalState]: {
      ...state[storename as keyof TGlobalState],
      data,
      loading: false,
      versionId,
      domainCode,
      employeeId
    }
  })),
  on(loadCitiesSuccess, (state, { data, storename, versionId, domainCode, employeeId }) => ({
    ...state,
    [storename as keyof TGlobalState]: {
      ...state[storename as keyof TGlobalState],
      data,
      loading: false,
      versionId,
      domainCode,
      employeeId
    }
  })),
  on(showRefreshJobOpening, (state, { show }): TGlobalState => {
    return { ...state, aux: { ...state.aux, refreshFeed: show } }
  }),
  on(loadJobOpeningSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, referralposting: { ...state[EGlobalStateStoreNames.Referralposting], data: { versionId, data }, loading: false, processId: EGlobalStateProcessId.Referralposting, employeeId, domainCode } }
  }),
  on(loadSocialWallWidgetSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, socialwallwidget: { ...state[EGlobalStateStoreNames.SocialWallWidget], data, loading: false, processId: EGlobalStateProcessId.SocialWallWidget, versionId, employeeId, domainCode } }
  }),
  on(loadRecruiterAccessSettingSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, recruiteraccesssetting: { ...state[EGlobalStateStoreNames.RecruiterAccessSetting], data, loading: false, processId: EGlobalStateProcessId.RecruiterAccessSetting, versionId, employeeId, domainCode } }
  }),
  on(loadGeneralSettingsSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, generalsettings: { ...state[EGlobalStateStoreNames.GeneralSettings], data, loading: false, processId: EGlobalStateProcessId.GeneralSettings, versionId, employeeId, domainCode } }
  }),
  on(loadRecruitmentGeneralSettingSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, recruitmentgeneralsetting: { ...state[EGlobalStateStoreNames.RecruitmentGeneralSetting], data, loading: false, processId: EGlobalStateProcessId.RecruitmentGeneralSetting, versionId, employeeId, domainCode } }
  }),
  on(loadOneAIFeatureSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, oneaifeature: { ...state[EGlobalStateStoreNames.OneAIFeature], data, loading: false, processId: EGlobalStateProcessId.OneAIFeature, versionId, employeeId, domainCode } }
  }),
  on(loadTaxRegimeSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, taxregime: { ...state[EGlobalStateStoreNames.TaxRegime], data, loading: false, processId: EGlobalStateProcessId.TaxRegime, versionId, employeeId, domainCode } }
  }),
  on(loadTimeOfficeExtensionSuccess,(state, { data, storename, versionId, domainCode, employeeId }): TGlobalState => {
    return { ...state,
      [storename]:{
        ...state[storename as keyof TGlobalState],
      data,
      loading: false,
      versionId,
      domainCode,
      employeeId,
      }
    }
  }),
  on(loadMoodbotDetailSuccess,(state, { data, storename, versionId, domainCode, employeeId }): TGlobalState => {
    return { ...state,
      [storename]:{
        ...state[storename as keyof TGlobalState],
      data,
      loading: false,
      versionId,
      domainCode,
      employeeId,
      }
    }
  }),
  on(loadMoodbotReasionListSuccess,(state, { data, storename, versionId, domainCode, employeeId }): TGlobalState => {
    return { ...state,
      [storename]:{
        ...state[storename as keyof TGlobalState],
      data,
      loading: false,
      versionId,
      domainCode,
      employeeId,
      }
    }
  }),
  on(loadPayrollGeneralSettingSuccess, (state, { data, versionId, employeeId, domainCode }): TGlobalState => {
    return { ...state, payrollgeneralsetting: { ...state[EGlobalStateStoreNames.PayrollGeneralSetting], data, loading: false, processId: EGlobalStateProcessId.PayrollGeneralSetting, versionId, employeeId, domainCode } }
  }),
  on(loadWorkflowInboxSettingSuccess, (state, { data, storename, versionId, domainCode, employeeId }): TGlobalState => {
    return {
      ...state,
      [storename]: {
        ...state[storename as keyof TGlobalState],
        data,
        loading: false,
        processId: EGlobalStateProcessId.WorkflowInboxSetting,
        versionId,
        domainCode,
        employeeId,
      }
    }
  }),
  on(loadHelpdeskTicketFeedbackSuccess, (state, { data, storename, versionId, domainCode, employeeId }): TGlobalState => {
    return {
      ...state,
      [storename]: {
        ...state[storename as keyof TGlobalState],
        data,
        loading: false,
        processId: EGlobalStateProcessId.HelpdeskTicketFeedback,
        versionId,
        domainCode,
        employeeId,
      }
    }
  }),
);

